import "../styles/notFound.css"
import STRINGS from "../globals/strings"
import IMAGES from "../globals/images"

const NotFound = () => {
  return (
    <div className='notfound-page'>
      <div className='logo-container'>
        <img src={IMAGES.LOGO} alt={STRINGS.CRICKSTAR_LOGO_ALT} className='found-logo' />
        {/* <span className="crickstar-name">Crickstar</span> */}
      </div>
      <div className='image-wrapper'>
        <img src={IMAGES.PAGE} alt="404 Page Not Found" className='not-found' />
      </div>
    </div>
  )
}

export default NotFound